import { useMutation, useQuery } from 'react-query';
import { useToast } from '@common/toast';
import { RemoteProfilesRepo } from '@repository/profiles/ProfilesRepo';
import { RemoteCodesRepo } from '@repository/codes/CodesRepo';
import JobGroupSTitleRq from '@domain/rq/match/JobGroupSTitleRq';
import IJobGroupWithTitlesVO from '@domain/vo/match/IJobGroupWithTitlesVO';

export const keys = ['match', 'jobGroupsWithTitles', 'list'];

const remoteProfilesRepo = new RemoteProfilesRepo();
const remoteCodesRepo = new RemoteCodesRepo();

const fetchJobGroupJobTitlesForUser = async () => {
  const { data } = await remoteProfilesRepo.fetchProfileConditions();
  return data.jobGroups;
};

const fetchJobGroupsWithTitlesDesc = async () => {
  const { data } = await remoteCodesRepo.fetchJobGroupsWithTitlesDesc();
  return data.jobGroupWithTitleDescriptions;
};

const fetchSaveJobGroupTitles = async (list: IJobGroupWithTitlesVO[]) => {
  const rq = list.filter((item) => item.jobTitleCodes?.length).map((item) => new JobGroupSTitleRq(item));

  const { data } = await remoteProfilesRepo.fetchSaveJobGroupTitles(rq);
  return data;
};

//설명 포함된 직군/직무 전체 조회
export default function useJobGroupsWithTitlesDesc() {
  return useQuery(keys, fetchJobGroupsWithTitlesDesc, {
    initialData: [],
  });
}

export function useSaveJobGroupTitles(onSuccess: () => void) {
  const Toast = useToast();

  return useMutation((rq: IJobGroupWithTitlesVO[]) => fetchSaveJobGroupTitles(rq), {
    onSuccess: onSuccess,
    onError: () => {
      Toast({ type: 'error', iconType: 'info', content: '저장을 실패하였습니다.' });
      return;
    },
  });
}

export function useJobGroupJobTitlesForUser(enabled: boolean) {
  return useQuery([...keys, 'jobSearch'], fetchJobGroupJobTitlesForUser, {
    enabled,
  });
}
